import {clsx} from 'clsx'
import type {ComponentProps} from 'react'
import rowStyles from './Row.module.css'
import styles from './ShowMore.module.css'

export type ShowMoreProps = ComponentProps<'button'>

export function ShowMore({children = 'Show more', className, ...props}: ShowMoreProps) {
  return (
    <button
      type="button"
      data-component="Sidebar.ShowMore"
      className={clsx(rowStyles.Row, styles.ShowMore, className)}
      {...props}
    >
      {children}
    </button>
  )
}
